(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[936],{

/***/ 12554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _badge_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9952);
/* harmony import */ var _badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_badge_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22120);
/* harmony import */ var remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13372);
/* harmony import */ var remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69826);
/* harmony import */ var remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89670);
/* harmony import */ var remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5__);







function Badge(param) {
    let { type , variant ="default" , size ="medium"  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    switch(type){
        case "bonus":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "".concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().badge), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().bonus), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[variant], " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[size]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3___default()), {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
                        children: t("bonus")
                    })
                ]
            });
        case "discount":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "".concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().badge), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().discount), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[variant], " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[size]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                    size: 20
                })
            });
        case "popular":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "".concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().badge), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().popular), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[variant], " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[size]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5___default()), {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
                        children: t("popular")
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {});
    }
}


/***/ }),

/***/ 77262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PrimaryButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98456);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23004);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_2__);




function PrimaryButton(param) {
    let { children , disabled , onClick , type ="button" , icon , loading =false , size ="medium" , id , fullWidth =true , rounded =true , danger =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        id: id,
        type: type,
        className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().primaryBtn), " ").concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[size], " ").concat(disabled ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled) : "", " ").concat(fullWidth ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().fullWidth) : "", " ").concat(rounded ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rounded) : "", " ").concat(danger ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().danger) : ""),
        disabled: disabled || loading,
        onClick: onClick,
        children: !loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                icon ? icon : "",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().text),
                    children: children
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: 22
        })
    });
}


/***/ }),

/***/ 20520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Empty; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _empty_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38733);
/* harmony import */ var _empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_empty_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_button_primaryButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77262);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* eslint-disable @next/next/no-img-element */ 




function Empty(param) {
    let { text , buttonText , link ="/"  } = param;
    const { push  } = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/images/delivery.webp",
                    alt: "Empty"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default().text),
                    children: text
                }),
                !!buttonText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default().actions),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_button_primaryButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: ()=>push(link),
                        children: buttonText
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 85028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ WEEK; }
/* harmony export */ });
const WEEK = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday"
];


/***/ }),

/***/ 20936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ShopList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./containers/shopList/shopList.module.scss
var shopList_module = __webpack_require__(74241);
var shopList_module_default = /*#__PURE__*/__webpack_require__.n(shopList_module);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 3 modules
var Skeleton = __webpack_require__(9526);
// EXTERNAL MODULE: ./components/shopCard/shopCard.module.scss
var shopCard_module = __webpack_require__(2598);
var shopCard_module_default = /*#__PURE__*/__webpack_require__.n(shopCard_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/shopLogo/shopLogo.module.scss
var shopLogo_module = __webpack_require__(10869);
var shopLogo_module_default = /*#__PURE__*/__webpack_require__.n(shopLogo_module);
// EXTERNAL MODULE: ./utils/getImage.ts
var getImage = __webpack_require__(95785);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/shopLogo/shopLogo.tsx





function ShopLogo(param) {
    let { data  } = param;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (shopLogo_module_default()).logo,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            fill: true,
            src: (0,getImage/* default */.Z)(data.logo_img),
            alt: (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title,
            sizes: "60px",
            quality: 90,
            loading: "lazy"
        })
    });
}

// EXTERNAL MODULE: ./containers/shopBadges/shopBadges.module.scss
var shopBadges_module = __webpack_require__(73102);
var shopBadges_module_default = /*#__PURE__*/__webpack_require__.n(shopBadges_module);
// EXTERNAL MODULE: ./components/badge/badge.tsx
var badge = __webpack_require__(12554);
;// CONCATENATED MODULE: ./containers/shopBadges/shopBadges.tsx




function ShopBadges(param) {
    let { data  } = param;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (shopBadges_module_default()).badge,
        children: [
            data.is_recommended && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                type: "popular",
                variant: !!((ref = data.discount) === null || ref === void 0 ? void 0 : ref.length) || !!data.bonus ? "circle" : "default",
                size: "large"
            }),
            !!((ref1 = data.discount) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                type: "discount",
                variant: data.is_recommended || !!data.bonus ? "circle" : "default",
                size: "large"
            }),
            !!data.bonus && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                type: "bonus",
                variant: data.is_recommended || !!((ref2 = data.discount) === null || ref2 === void 0 ? void 0 : ref2.length) ? "circle" : "default",
                size: "large"
            })
        ]
    });
}

// EXTERNAL MODULE: ./hooks/useLocale.tsx
var useLocale = __webpack_require__(18074);
// EXTERNAL MODULE: ./hooks/useShopWorkingSchedule.tsx
var useShopWorkingSchedule = __webpack_require__(73444);
// EXTERNAL MODULE: ./components/icons.tsx
var icons = __webpack_require__(6684);
;// CONCATENATED MODULE: ./components/verifiedComponent/verifiedComponent.tsx


function VerifiedComponent() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        style: {
            display: "block",
            minWidth: "16px",
            height: "auto"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* VerifiedIcon */.SA, {})
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Rating/Rating.js + 4 modules
var Rating = __webpack_require__(18339);
// EXTERNAL MODULE: ./utils/shopHref.ts
var shopHref = __webpack_require__(76896);
// EXTERNAL MODULE: ./contexts/settings/settings.context.tsx
var settings_context = __webpack_require__(21697);
;// CONCATENATED MODULE: ./utils/distance.ts
// utils/distance.ts
const toRad = (v)=>v * Math.PI / 180;
/** Calcola la distanza in km tra due coordinate (formula Haversine) */ function haversineKm(lat1, lon1, lat2, lon2) {
    const R = 6371; // raggio terrestre medio in km
    if (lat1 == null || lon1 == null || lat2 == null || lon2 == null || isNaN(Number(lat1)) || isNaN(Number(lon1)) || isNaN(Number(lat2)) || isNaN(Number(lon2))) return NaN;
    const dLat = toRad(Number(lat2) - Number(lat1));
    const dLon = toRad(Number(lon2) - Number(lon1));
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(Number(lat1))) * Math.cos(toRad(Number(lat2))) * Math.sin(dLon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}
/** Restituisce una stringa leggibile: metri se <1km, altrimenti 1 decimale */ function formatDistance(km) {
    if (!km || !Number.isFinite(km)) return "";
    if (km < 1) return "".concat(Math.round(km * 1000), " m");
    return "".concat(km.toFixed(1), " km");
}

;// CONCATENATED MODULE: ./components/shopCard/shopCard.tsx














// utils distanza

/** Estrae lat/lon da vari formati possibili */ function extractCoords(input) {
    if (!input) return null;
    // oggetto classico
    if (typeof input === "object") {
        var ref, ref1;
        var _latitude, ref2, ref3;
        const lat = (ref3 = (ref2 = (_latitude = input.latitude) !== null && _latitude !== void 0 ? _latitude : input.lat) !== null && ref2 !== void 0 ? ref2 : input.latitud) !== null && ref3 !== void 0 ? ref3 : typeof input.location === "string" ? Number((ref = String(input.location).match(/-?\d+(\.\d+)?/)) === null || ref === void 0 ? void 0 : ref[0]) : undefined;
        var _longitude, ref4, ref5;
        const lon = (ref5 = (ref4 = (_longitude = input.longitude) !== null && _longitude !== void 0 ? _longitude : input.lon) !== null && ref4 !== void 0 ? ref4 : input.lng) !== null && ref5 !== void 0 ? ref5 : typeof input.location === "string" ? Number((ref1 = String(input.location).match(/-?\d+(\.\d+)?/g)) === null || ref1 === void 0 ? void 0 : ref1[1]) : undefined;
        if (Number.isFinite(lat) && Number.isFinite(lon)) {
            return {
                lat: Number(lat),
                lon: Number(lon)
            };
        }
    }
    // stringa "lat, lon" o "[lat, lon]"
    if (typeof input === "string") {
        const nums = input.match(/-?\d+(\.\d+)?/g);
        if (nums && nums.length >= 2) {
            const lat1 = Number(nums[0]);
            const lon1 = Number(nums[1]);
            if (Number.isFinite(lat1) && Number.isFinite(lon1)) {
                return {
                    lat: lat1,
                    lon: lon1
                };
            }
        }
    }
    return null;
}
/** Prova varie chiavi di localStorage per la posizione utente */ function getUserCoordsFromStorage() {
    const keys = [
        "location",
        "deliveryLocation",
        "selectedAddress",
        "delivery_address",
        "user_location",
        "map_address",
        "address"
    ];
    for (const k of keys){
        try {
            var ref;
            const raw = localStorage.getItem(k);
            if (!raw) continue;
            // può essere stringa "lat,lon" oppure JSON
            const parsed = (()=>{
                try {
                    return JSON.parse(raw);
                } catch (e) {
                    return raw;
                }
            })();
            const fromParsed = extractCoords(parsed === null || parsed === void 0 ? void 0 : (ref = parsed.address) === null || ref === void 0 ? void 0 : ref.location) || extractCoords(parsed === null || parsed === void 0 ? void 0 : parsed.location) || extractCoords(parsed);
            if (fromParsed) return fromParsed;
        } catch (e) {
        // ignora
        }
    }
    return null;
}
function ShopCard(param) {
    let { data  } = param;
    var ref, ref1;
    const { t  } = (0,useLocale/* default */.Z)();
    const { isShopClosed , workingSchedule  } = (0,useShopWorkingSchedule/* default */.Z)(data);
    // posizione utente dal SettingsContext (viene aggiornata da change address)
    const { location  } = (0,settings_context/* useSettings */.r)();
    const [distanceText, setDistanceText] = (0,react.useState)("");
    // coordinate negozio (calcolate una volta)
    const shopCoords = (0,react.useMemo)(()=>{
        var ref, ref1;
        return extractCoords({
            latitude: data === null || data === void 0 ? void 0 : data.latitude,
            longitude: data === null || data === void 0 ? void 0 : data.longitude
        }) || extractCoords(data === null || data === void 0 ? void 0 : data.location) || extractCoords({
            latitude: data === null || data === void 0 ? void 0 : (ref = data.translation) === null || ref === void 0 ? void 0 : ref.latitude,
            longitude: data === null || data === void 0 ? void 0 : (ref1 = data.translation) === null || ref1 === void 0 ? void 0 : ref1.longitude
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        if (!shopCoords) return;
        const setFromCoords = (lat, lon)=>{
            const km = haversineKm(lat, lon, shopCoords.lat, shopCoords.lon);
            setDistanceText(formatDistance(km));
        };
        // 1) se nel context c'è la location (es. "41.45,15.55") → prioritaria
        const ctxCoords = extractCoords(location);
        if (ctxCoords) {
            setFromCoords(ctxCoords.lat, ctxCoords.lon);
            return;
        }
        // 2) fallback: localStorage
        const stored =  true ? getUserCoordsFromStorage() : 0;
        if (stored) {
            setFromCoords(stored.lat, stored.lon);
            return;
        }
        // 3) ultima spiaggia: geoloc browser
        if (typeof navigator !== "undefined" && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((pos)=>{
                setFromCoords(pos.coords.latitude, pos.coords.longitude);
            }, ()=>{
                // lascia vuoto se non disponibile
                setDistanceText("");
            }, {
                enableHighAccuracy: false,
                maximumAge: 60000,
                timeout: 3000
            });
        } else {
            setDistanceText("");
        }
    }, [
        location,
        shopCoords
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        href: (0,shopHref/* shopHref */.E)(data),
        className: "".concat((shopCard_module_default()).wrapper),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (shopCard_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    fill: true,
                    src: (0,getImage/* default */.Z)(data.background_img),
                    alt: (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title,
                    sizes: "400px",
                    quality: 90,
                    loading: "lazy"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (shopCard_module_default()).shopLogo,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopLogo, {
                    data: data
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (shopCard_module_default()).body,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopBadges, {
                        data: data
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shopCard_module_default()).titleContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "".concat((shopCard_module_default()).title, " ").concat(!(data === null || data === void 0 ? void 0 : data.verify) && (shopCard_module_default()).maxWidth),
                                children: (ref1 = data.translation) === null || ref1 === void 0 ? void 0 : ref1.title
                            }),
                            !!(data === null || data === void 0 ? void 0 : data.verify) && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifiedComponent, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (shopCard_module_default()).text,
                        children: !isShopClosed ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                workingSchedule === null || workingSchedule === void 0 ? void 0 : workingSchedule.from,
                                " - ",
                                workingSchedule === null || workingSchedule === void 0 ? void 0 : workingSchedule.to
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("closed")
                        })
                    }),
                    distanceText && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            marginTop: 6,
                            fontSize: 13,
                            color: "var(--secondary-700)"
                        },
                        children: [
                            "+",
                            distanceText
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shopCard_module_default()).rating,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                value: (data === null || data === void 0 ? void 0 : data.r_avg) || 0,
                                readOnly: true,
                                size: "small",
                                precision: 0.5,
                                name: "ratingIcon",
                                color: "var(--orange)",
                                className: (shopCard_module_default()).ratingIcon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (shopCard_module_default()).ratingCount,
                                children: (data === null || data === void 0 ? void 0 : data.r_count) || 0
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(22120);
// EXTERNAL MODULE: ./components/button/load-more.tsx
var load_more = __webpack_require__(94627);
// EXTERNAL MODULE: ./components/empty/empty.tsx
var empty = __webpack_require__(20520);
;// CONCATENATED MODULE: ./containers/shopList/shopList.tsx








function ShopList(param) {
    let { title , shops , loading , fetchNextPage , hasNextPage =false , fetchingNextPage =false  } = param;
    const { t  } = (0,es/* useTranslation */.$G)();
    const isDesktop = (0,useMediaQuery/* default */.Z)("(min-width:1140px)");
    const handleLoadNexPage = ()=>{
        if (hasNextPage && fetchNextPage) {
            fetchNextPage();
        }
    };
    if (!loading && !(shops === null || shops === void 0 ? void 0 : shops.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(empty["default"], {
            text: t("no.shops.found")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (shopList_module_default()).container,
        style: {
            display: !loading && shops.length === 0 ? "none" : "block"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shopList_module_default()).wrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shopList_module_default()).header,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (shopList_module_default()).title,
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    spacing: isDesktop ? 4 : 2,
                    children: !loading ? shops.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            lg: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopCard, {
                                data: item
                            })
                        }, item.id)) : Array.from(new Array(4)).map((_, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            lg: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "rectangular",
                                className: (shopList_module_default()).shimmer
                            })
                        }, "shops" + idx))
                }),
                hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shopList_module_default()).loadMore,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(load_more/* default */.Z, {
                        loading: fetchingNextPage,
                        onClick: handleLoadNexPage,
                        children: t("load.more")
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 73444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useShopWorkingSchedule; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_weekdays__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85028);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);




function useShopWorkingSchedule(data) {
    const { order  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((state)=>state.order);
    const { workingSchedule , isShopClosed , isOpen , isTodayDisabled  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        var ref, ref1;
        const isSelectedDeliveryDate = order.shop_id === (data === null || data === void 0 ? void 0 : data.id) && !!order.delivery_date;
        const today = isSelectedDeliveryDate ? order.delivery_date : dayjs__WEBPACK_IMPORTED_MODULE_1___default()().format("YYYY-MM-DD");
        const weekDay = constants_weekdays__WEBPACK_IMPORTED_MODULE_3__/* .WEEK */ .p[isSelectedDeliveryDate ? dayjs__WEBPACK_IMPORTED_MODULE_1___default()(order.delivery_date).day() : dayjs__WEBPACK_IMPORTED_MODULE_1___default()().day()];
        const foundedSchedule = data === null || data === void 0 ? void 0 : (ref = data.shop_working_days) === null || ref === void 0 ? void 0 : ref.find((item)=>item.day === weekDay);
        const isHoliday = data === null || data === void 0 ? void 0 : (ref1 = data.shop_closed_date) === null || ref1 === void 0 ? void 0 : ref1.some((item)=>dayjs__WEBPACK_IMPORTED_MODULE_1___default()(item.day).isSame(isSelectedDeliveryDate ? dayjs__WEBPACK_IMPORTED_MODULE_1___default()(order.delivery_date) : dayjs__WEBPACK_IMPORTED_MODULE_1___default()()));
        const isClosed = !(data === null || data === void 0 ? void 0 : data.open) || isHoliday;
        let schedule = {};
        let isTimePassed = false;
        let isTimeDidNotStart = false;
        try {
            if (foundedSchedule) {
                schedule = {
                    ...foundedSchedule
                };
                schedule.from = schedule.from.replace("-", ":");
                schedule.to = schedule.to.replace("-", ":");
                isTimePassed = dayjs__WEBPACK_IMPORTED_MODULE_1___default()().isAfter("".concat(today, " ").concat(schedule.to));
                isTimeDidNotStart = dayjs__WEBPACK_IMPORTED_MODULE_1___default()().isBefore("".concat(today, " ").concat(schedule.from));
            }
        } catch (err) {
            console.log("err => ", err);
        }
        return {
            workingSchedule: schedule,
            isShopClosed: schedule.disabled || isClosed || isTimePassed || isTimeDidNotStart,
            isOpen: Boolean(data === null || data === void 0 ? void 0 : data.open),
            isTodayDisabled: schedule.disabled
        };
    }, [
        data,
        order.delivery_date,
        order.shop_id
    ]);
    return {
        workingSchedule,
        isShopClosed,
        isOpen,
        isTodayDisabled
    };
}


/***/ }),

/***/ 76896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ shopHref; }
/* harmony export */ });
/* harmony import */ var utils_slug__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83047);
// utils/shopHref.ts

function shopHref(s) {
    var ref;
    const title = (s === null || s === void 0 ? void 0 : (ref = s.translation) === null || ref === void 0 ? void 0 : ref.title) || (s === null || s === void 0 ? void 0 : s.name) || "";
    return "/shop/".concat(s.id, "/").concat((0,utils_slug__WEBPACK_IMPORTED_MODULE_0__/* .compactSlug */ .Z)(title));
}


/***/ }),

/***/ 83047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ compactSlug; },
/* harmony export */   "l": function() { return /* binding */ slugify; }
/* harmony export */ });
// utils/slug.ts
/**
 * slugify: usato per i PRODOTTI
 * Risultato:
 * - minuscolo
 * - solo lettere e numeri
 * - trattini come separatori
 * Esempio: "Uova Omega 3 Fresche" → "uova-omega-3-fresche"
 */ function slugify(input) {
    return (input || "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "") // rimuove accenti
    .toLowerCase().trim().replace(/[^a-z0-9]+/g, "-") // tutto ciò che non è a-z0-9 diventa "-"
    .replace(/^-+|-+$/g, ""); // rimuove trattini ai bordi
}
/**
 * compactSlug: usato per gli SHOP
 * Risultato:
 * - minuscolo
 * - solo lettere e numeri
 * - nessun separatore
 * Esempio: "Avicola del Sole" → "avicoladelsole"
 */ function compactSlug(input) {
    return (input || "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "") // rimuove accenti
    .toLowerCase().replace(/[^a-z0-9]/g, ""); // elimina tutto ciò che non è a-z0-9
}


/***/ }),

/***/ 9952:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__BHeKC","default":"badge_default__18BvY","circle":"badge_circle__mQVZ_","text":"badge_text__cdsyf","large":"badge_large__bhCOW","medium":"badge_medium__3BTPx","bonus":"badge_bonus__Ice67","discount":"badge_discount__gVAeQ","popular":"badge_popular__ywwJB"};

/***/ }),

/***/ 38733:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"empty_wrapper__nwTin","text":"empty_text__oRHIv","actions":"empty_actions__NNcWA"};

/***/ }),

/***/ 2598:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"shopCard_wrapper__eLDR6","header":"shopCard_header__ndTnF","shopLogo":"shopCard_shopLogo__YBVUk","body":"shopCard_body__RaioU","titleContainer":"shopCard_titleContainer__PoAO_","title":"shopCard_title__ZOeFL","maxWidth":"shopCard_maxWidth__hzAq9","text":"shopCard_text__N8BjM","rating":"shopCard_rating__e7b0N","ratingIcon":"shopCard_ratingIcon___i8oO","ratingCount":"shopCard_ratingCount__okJy2","distance":"shopCard_distance__kOfRi"};

/***/ }),

/***/ 10869:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"shopLogo_logo__RFCaX"};

/***/ }),

/***/ 73102:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"badge":"shopBadges_badge__NpYKe"};

/***/ }),

/***/ 74241:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"shopList_container__dXd4J","wrapper":"shopList_wrapper__q4bQb","header":"shopList_header__8uPMd","title":"shopList_title__D3BSf","loadMore":"shopList_loadMore__xxuRm","shimmer":"shopList_shimmer__tOM85"};

/***/ })

}]);